import { Validator, AbstractControl, ValidationErrors, NG_VALIDATORS, NgControl } from '@angular/forms';
import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector:'[trim]',
})
export class ValueTrimmer{
  element:any;
  constructor(el:ElementRef,private ctrl:NgControl){
    this.element=el.nativeElement
  }
  @HostListener('blur') onMouseEnter() {
    this.ctrl.control.setValue(this.element.value.trim())
  }
}
